import { Box } from "@mui/material";
import ResultLabel from "catalog/components/ResultLabel";
import { Highlight } from "~/types/interfaces/catalogResponse";

const formatter = new Intl.ListFormat("en");

const DISPLAY_MAPPINGS: Record<string, string> = {
  "columns.name": "column name",
  "columns.description": "column description",
  "tags.tagFQN.parts": "tags",
  "table.tags.tagFQN.parts": "dataset tags",
  "table.description": "dataset description",
};

const ResultMatches = (props: { highlight: Highlight }) => {
  const mappedMatches = Object.entries(props.highlight)
    .sort((a, b) => b.length - a.length)
    .filter(([key]) => DISPLAY_MAPPINGS[key])
    .map(([key, matches]) => {
      const label = DISPLAY_MAPPINGS[key];
      return `${matches.length} in ${label}`;
    });

  if (!mappedMatches.length) {
    return null;
  }

  return (
    <Box display="flex" alignItems="center">
      <ResultLabel>More Matches:</ResultLabel>
      <Box
        sx={{
          display: "flex",
          gap: 0.5,
          flexWrap: "wrap",
          alignItems: "center",
          fontSize: 13,
        }}
      >
        {formatter.format(mappedMatches)}
      </Box>
    </Box>
  );
};

export default ResultMatches;
